import usePersistedState from './usePersistedState'

export const RECENT_MEMBER = 'RECENT_MEMBER'
export const RECENT_TEST_MEMBER = 'RECENT_TEST_MEMBER'
export const RECENT_PREVIEW_AS_MEMBER = 'RECENT_PREVIEW_AS_MEMBER'
export const RECENT_CANNED_RESPONSES = 'RECENT_CANNED_RESPONSES'
export const RECENT_FIELDS = 'RECENT_FIELDS'

export default function useLocalStorage<T>(key: string, initialValue: T) {
  return usePersistedState<T>(key, initialValue)
}
